<template>
    <Dashboard
        :title="__('Product reviews', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Product reviews', null, $page.props.profile_locale)"
            :backLink="route('dashboard.admin.products')"
            :description="'<span class=\'text-red-700\'>' + product.name + '</span>'"
        />

        <div class="overflow-auto w-full shadow-md rounded-md">
            <table class="w-full whitespace-nowrap">
                <thead class="relative">
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700"
                    >
                        <th class="px-4 py-3">{{__('Question', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Answer', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                    </tr>
                    <InertiaLink
                        :href="route('dashboard.admin.product.question.create', product.id)"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 rounded-full overflow-hidden hover:text-white text-gray-200"
                    >
                        <SvgIcon
                            name="plus-circle"
                            class="mx-auto "
                        />

                    </InertiaLink>
                </thead>
                <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr v-for="question in questions" :key="question.id"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-2 font-bold">
                            {{ question.question }}
                        </td>
                        <td class="px-4 py-2 w-20">
                            {{ question.answer.trimText(50) }}
                        </td>
                        <td class="px-4 py-2 text-sm flex">
                            <IconLink
                                color="gray"
                                icon="pencil"
                                class="p-1 mr-1"
                                :href="route('dashboard.admin.product.question.edit', {
                                    product: product.id,
                                    question: question.id
                                })"
                            ></IconLink>
                            <IconLink
                                color="red"
                                icon="trash"
                                class="p-1 ml-auto"
                                :href="route('product.question.remove', question.id)"
                            ></IconLink>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!questions.length" class="p-3">Produkt nie posiada żadnego pytania</div>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import SvgIcon from 'UI/SvgIcon';
import IconLink from 'UI/IconLink';


export default {
    components: {
        Dashboard,
        Heading,
        SvgIcon,
        IconLink
    },

    props: ['questions','product'],
}
</script>

<style>

</style>
